module.exports = __webpack_public_path__ + "static/ArticlesPageHero40@2x.e722f99e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ArticlesPageHero40@2x.jpg
// module id = 659
// module chunks = 174759553322802